
// noinspection JSAnnotator

export default {
	dev: {
		global: {
			API: 'https://www.d.nexon.com/wallet-api',
			account: 'https://www.d.nexon.com/account',
			checkout: 'https://www.d.nexon.com/checkout',
		},
		th: {
			API: 'https://th.d.nexon.com/wallet-api',
			account: 'https://th.d.nexon.com/account',
			checkout: 'https://th.d.nexon.com/checkout',
		},
		tw: {
			API: 'https://tw.d.nexon.com/wallet-api',
			account: 'https://tw.d.nexon.com/account',
			checkout: 'https://tw.d.nexon.com/checkout',
		},
		sea: {
			API: 'https://sea.d.nexon.com/wallet-api',
			account: 'https://sea.d.nexon.com/account',
			checkout: 'https://sea.d.nexon.com/checkout',
		},
	},
	testPre: {
		global: {
			API: 'https://test-pre-www.nexon.com/wallet-api',
			account: 'https://test-pre-www.nexon.com/account',
			checkout: 'https://test-pre-www.nexon.com/checkout',
		},
		th: {
			API: 'https://test-pre-th.nexon.com/wallet-api',
			account: 'https://test-pre-th.nexon.com/account',
			checkout: 'https://test-pre-th.nexon.com/checkout',
		},
		tw: {
			API: 'https://test-pre-tw.nexon.com/wallet-api',
			account: 'https://test-pre-tw.nexon.com/account',
			checkout: 'https://test-pre-tw.nexon.com/checkout',
		},
		sea: {
			API: 'https://test-pre-sea.nexon.com/wallet-api',
			account: 'https://test-pre-sea.nexon.com/account',
			checkout: 'https://test-pre-sea.nexon.com/checkout',
		},
	},
	test: {
		global: {
			API: 'https://test-www.nexon.com/wallet-api',
			account: 'https://test-www.nexon.com/account',
			checkout: 'https://test-www.nexon.com/checkout',
		},
		th: {
			API: 'https://test-th.nexon.com/wallet-api',
			account: 'https://test-th.nexon.com/account',
			checkout: 'https://test-th.nexon.com/checkout',
		},
		tw: {
			API: 'https://test-tw.nexon.com/wallet-api',
			account: 'https://test-tw.nexon.com/account',
			checkout: 'https://test-tw.nexon.com/checkout',
		},
		sea: {
			API: 'https://test-sea.nexon.com/wallet-api',
			account: 'https://test-sea.nexon.com/account',
			checkout: 'https://test-sea.nexon.com/checkout',
		},
	},
	pre: {
		global: {
			API: 'https://pre-www.nexon.com/wallet-api',
			account: 'https://pre-www.nexon.com/account',
			checkout: 'https://pre-www.nexon.com/checkout',
		},
		th: {
			API: 'https://pre-th.nexon.com/wallet-api',
			account: 'https://pre-th.nexon.com/account',
			checkout: 'https://pre-th.nexon.com/checkout',
		},
		tw: {
			API: 'https://pre-tw.nexon.com/wallet-api',
			account: 'https://pre-tw.nexon.com/account',
			checkout: 'https://pre-tw.nexon.com/checkout',
		},
		sea: {
			API: 'https://pre-sea.nexon.com/wallet-api',
			account: 'https://pre-sea.nexon.com/account',
			checkout: 'https://pre-sea.nexon.com/checkout',
		},
	},
	prod: {
		global: {
			API: 'https://www.nexon.com/wallet-api',
			account: 'https://www.nexon.com/account',
			checkout: 'https://www.nexon.com/checkout',
		},
		th: {
			API: 'https://th.nexon.com/wallet-api',
			account: 'https://th.nexon.com/account',
			checkout: 'https://th.nexon.com/checkout',
		},
		tw: {
			API: 'https://tw.nexon.com/wallet-api',
			account: 'https://tw.nexon.com/account',
			checkout: 'https://tw.nexon.com/checkout',
		},
		sea: {
			API: 'https://sea.nexon.com/wallet-api',
			account: 'https://sea.nexon.com/account',
			checkout: 'https://sea.nexon.com/checkout',
		},
	}
};




// WEBPACK FOOTER //
// ./src/config/environment-config.js